import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';

@Component({
  selector: 'school-adjustment',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './school-adjustment.component.html',
  styleUrl: './school-adjustment.component.css'
})
export class SchoolAdjustmentComponent implements OnInit {

  @Input() parentInterviewData: any;
  @Output() onSaveSection3 = new EventEmitter<any>();

  yesNo = EYesNo;
  schoolAdjustmentForm: FormGroup = new FormGroup([]);
  
  questionList = [
    {
      question: "How does your child like school? *",
      formControlName: "child_like_school",
    },
    {
      question: "How often does your child do homework? *",
      formControlName: "child_homework",
    },
    {
      question: "What are your child's teachers like? *",
      formControlName: "child_teacher",
    }
  ]

  radioQuestions = [
    {
      id: 'suspension',
      questionText: "Has your child ever been suspended or expelled from school? *",
      formControlName: 'suspension',
      infoFormControlName: 'suspension_information'
    },
    {
      id: 'concerns_school_personnel',
      questionText: "Have you ever met with school personnel about concerns in the past? *",
      formControlName: 'concerns_school_personnel',
      infoFormControlName: 'concerns_school_personnel_information'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}
  
  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['parentInterviewData'] && this.parentInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      const defaultValue = this.parentInterviewData && this.parentInterviewData[question.formControlName] !== undefined
                           ? this.parentInterviewData[question.formControlName]
                           : this.yesNo.No;

      group[question.formControlName] = new FormControl(
          String(defaultValue),
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.parentInterviewData?.[question.infoFormControlName] || '', disabled: this.parentInterviewData?.[question.infoFormControlName] ? false : true });
    });
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.parentInterviewData?.[question.formControlName] || '', Validators.required);
    });

    this.schoolAdjustmentForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.schoolAdjustmentForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.schoolAdjustmentForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }          
        });
      }
    });
  }

  saveSchoolAdjustment(): void {
    if (this.schoolAdjustmentForm.valid) {
      this.onSaveSection3.emit(this.schoolAdjustmentForm.value);
    }
  }

}
